import {
  IDynamicBindableValue,
  IDynamicItem,
  IId,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { StrictExtract, StrictOmit } from '@epicuro-next/utilities';

export function getProvider<T extends IDynamicItem & Required<IId>>(
  instance: T,
  property: keyof T['data'],
): IDynamicBindableValue {
  return getIdProvider(instance.id, property as string);
}

export function getIdProvider(
  id: string,
  property: string,
): IDynamicBindableValue {
  return {
    provider: `id:${id}`,
    property,
  };
}

export function createInstance<T extends IDynamicItem>(object: T): T {
  return object;
}

type IDynamicItemWithChildren<Y> = StrictOmit<IDynamicItem, 'children'> & {
  [k in StrictExtract<keyof IDynamicItem, 'children'>]: Y[];
};
export function createInstanceWithChildren<
  T extends IDynamicItemWithChildren<IDynamicItem>,
>(
  object: T,
): StrictOmit<T, 'children'> & {
  [k in StrictExtract<keyof IDynamicItem, 'children'>]: IDynamicItem[];
} {
  return object;
}
